import api from '@/utils/api'

export default {
    getAssignments(page, size, query, sort) {
        let filter = null
        if (Object.keys(query).length > 0) {
            filter = query
        }
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        let sortBy = encodeURIComponent(`[${sort}]`)
        return api.get(`assignments` + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '') + (sort ? `&sort=${sortBy}` : ''))
    },

    exportAssignments(query, sort) {
        let filter = null
        Object.keys(query).forEach(key => {
            if (!query[key]) {
                delete query[key]
            }
        })
        if (Object.keys(query).length > 0) {
            filter = query
        }
        let sortBy = encodeURIComponent(`[${sort}]`)
        return api.get(`assignments/export` + (filter ? `?filter=${encodeURIComponent(JSON.stringify(filter))}` : '') + (sort ? `&sort=${encodeURIComponent(sortBy)}` : ''))
    },

    getAssignment(id) {
        return api.get(`assignments/${id}`)
    },

    getOnContractorsBetweenDates(query) {
        return api.get(`assignments/contractors/on-dates?startDate=${query.startDate}&endDate=${query.endDate}`)
    },

    getAssignmentBySr(sr) {
        return api.get(`assignments/by-sr/${sr}`)
    },

    // getAssignmentByAddressLike(page, size, address) {
    //     let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
    //     return api.get(`assignments/by-address-like/${address}` + (page ? range : ''))
    // },
    sendAssignmentBackToContractor(id) {
        return api.post(`assignments/${id}/contractor-update`)
    },

    createAssignment(data) {
        return api.post('assignments', data)
    },

    updateAssignmentTab(tab, id, data) {
        return api.put(`assignments/${id}/${tab}`, data)
    },

    deleteAssignment(id) {
        return api.delete(`assignments/${id}`)
    },
    canEditTab(id, tab) {
        return api.get(`assignments/${id}/can-edit/${tab}`)
    },
    import(formData) {
        return api.uploadFile(`assignments/import`, formData)
    },
    importFsmMalfunctions(formData) {
        return api.uploadFile(`assignments/import-fsm-malfunction`, formData)
    },
    importProdesmeusi(id, formData) {
        return api.uploadFile(`assignments/${id}/import-prodesmeusi`, formData)
    },
    multipleAssignmentToContractor(data) {
        return api.post('assignments/multiple-to-contractor', data)
    },
    appointmentUpdate(id, data) {
        return api.post(`assignments/${id}/appointment-update`, data)
    },
    getAllAks() {
        return api.get(`assignments/aks`)
    }
}
